module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/relatedlink_01-fb385f332ab6cc1684965ec66efa7564.jpg";